import { z } from 'zod'

export const RemedyTypeEnum = [
  'DROPS',
  'PILLS',
  'ML',
  'G',
  'MG',
  'ENVELOPE'
] as const

export const RemedyType = z.enum(RemedyTypeEnum)
export type RemedyType = z.infer<typeof RemedyType>
